"use client";

import type { ReactNode } from "react";
import styles from "./VibrantOrbBackground.module.scss";

interface VibrantOrbBackgroundProps {
  children: ReactNode;
}

/**
 * A background component that displays a vibrant animated orb effect with a blue container.
 * Used for login and other authentication pages.
 */
export function VibrantOrbBackground({ children }: VibrantOrbBackgroundProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.background}></div>
        <div className={styles.orb}></div>
        {children}
      </div>
    </div>
  );
}
